import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/pro-solid-svg-icons";
import { TenantLocationType } from '../../../domain/tenantLocations/tenantLocation';
import ShopMarkerSmall from '../RouteMap/ShopMarkerSmall';

interface MapShopAddressProps {
  tenantLocations?: any[];
  onManageShopAddress: () => void;
}

const MapShopAddress = ({ tenantLocations, onManageShopAddress }: MapShopAddressProps) => {
  return (
    <div style={{
      position: 'absolute',
      top: '10px',
      left: '50px',
      zIndex: 1,
      backgroundColor: 'white',
      borderRadius: '20px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      maxWidth: '400px',
      border: '1px solid #e8e8e8'
    }}
    onClick={onManageShopAddress}>
      {tenantLocations?.find(tl => tl.type === TenantLocationType.Shop) && (
        <ShopMarkerSmall />
      )}
      
      {tenantLocations && tenantLocations.length > 0 ? (
        tenantLocations.find(tl => tl.type === TenantLocationType.Shop) ? (
          <span style={{ color: '#333', fontSize: '12px', whiteSpace: 'nowrap', textDecoration: 'underline' }}>
            {tenantLocations.find(tl => tl.type === TenantLocationType.Shop)?.address1}{' '}
            {tenantLocations.find(tl => tl.type === TenantLocationType.Shop)?.city}{' '}
            {tenantLocations.find(tl => tl.type === TenantLocationType.Shop)?.stateCode}, {' '}
            {tenantLocations.find(tl => tl.type === TenantLocationType.Shop)?.zip}
          </span>
        ) : (
          <span style={{ color: '#999', fontStyle: 'italic', fontSize: '12px', textDecoration: 'underline' }}>
            Shop address is required
          </span>
        )
      ) : (
        <span style={{ color: '#FF5C35', fontStyle: 'italic', fontSize: '12px', display: 'flex', alignItems: 'center', textDecoration: 'underline' }}>
          <FontAwesomeIcon icon={faWarning} style={{ marginRight: '6px', fontSize: '12px' }} />
          Shop address is required
        </span>
      )}
    </div>
  );
};

export default MapShopAddress;